
export default {
  auth: false,
  layout: 'login',
  head () {
    return {
      titleTemplate: this.$t('terms') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:  this.$t('meta.regulamin')
        }
      ],
    }
  },
}
